'use client';

import { c as _c } from "react/compiler-runtime";
import type { FundingCheckout } from '@morfi/onramp-sdk/react';
import type { AddCardEvent, MoonPayWebProvider } from '@morfi/onramp-sdk/web';
import { useTranslations } from 'next-intl';
import { type JSX, useEffect, useEffectEvent, useRef } from 'react';
import { AnimatedButton } from '@/components/ui/animated-button';
import { logger } from '@/lib/telemetry/logger';
export function FundingCardEntry(t0) {
  const $ = _c(18);
  const {
    provider,
    checkout
  } = t0;
  const t = useTranslations("onramp");
  const container = useRef(null);
  let t1;
  if ($[0] !== checkout) {
    t1 = event => checkout.cardEntryEvent(event);
    $[0] = checkout;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const notify = useEffectEvent(t1);
  let t2;
  if ($[2] !== checkout.cardEntryActive || $[3] !== notify || $[4] !== provider) {
    t2 = () => {
      if (!checkout.cardEntryActive || !container.current) {
        return;
      }
      const element = container.current;
      let active = true;
      let frame;
      const disposeFrame = function disposeFrame() {
        frame?.dispose();
        frame = undefined;
      };
      const failed = function failed() {
        if (!active) {
          return;
        }
        active = false;
        disposeFrame();
        logger.warn("onramp.card_entry_failed", {
          phase: "card_entry"
        });
        notify({
          kind: "error",
          payload: {
            code: "generic",
            message: "frame_unavailable"
          }
        });
      };
      const mount = async function mount() {
        await Promise.resolve();
        if (!active) {
          return;
        }
        try {
          const result = await provider.setupAddCard({
            container: element,
            onEvent: event_0 => {
              if (!active) {
                return;
              }
              if (event_0.kind === "error") {
                failed();
                return;
              }
              if (event_0.kind === "complete") {
                active = false;
                disposeFrame();
              }
              notify(event_0);
            }
          });
          if (result.ok) {
            if (active) {
              frame = result.value;
            } else {
              result.value.dispose();
            }
          } else {
            failed();
          }
        } catch {
          if (active) {
            logger.warn("onramp.card_entry_setup_failed", {
              phase: "card_entry"
            });
          }
          failed();
        }
      };
      mount();
      return () => {
        active = false;
        disposeFrame();
        element.replaceChildren();
      };
    };
    $[2] = checkout.cardEntryActive;
    $[3] = notify;
    $[4] = provider;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== checkout.cardEntryActive || $[7] !== provider) {
    t3 = [provider, checkout.cardEntryActive];
    $[6] = checkout.cardEntryActive;
    $[7] = provider;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  useEffect(t2, t3);
  const t4 = checkout.cardEntryActive === false;
  let t5;
  if ($[9] !== t4) {
    t5 = <div ref={container} hidden={t4} className="h-112 w-full" />;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== checkout.cardEntryActive || $[12] !== checkout.retry || $[13] !== t) {
    t6 = !checkout.cardEntryActive ? <AnimatedButton variant="secondary" onClick={checkout.retry}>{t("retry")}</AnimatedButton> : null;
    $[11] = checkout.cardEntryActive;
    $[12] = checkout.retry;
    $[13] = t;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t5 || $[16] !== t6) {
    t7 = <div className="rr-block flex flex-col gap-3" data-private="true">{t5}{t6}</div>;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
}